import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
       light: {
        primary: "#ff3c00",   // Main brand red
        secondary: "#f7941d", // Bright orange (gradient partner)
        accent: "#ffc300",    // Logo shine (yellow)
        info: "#ff8a3d",      // Light orange tint (optional)
        background: "#ffd6cc" // Optional clean background
      },
      options: {
        customProperties: true,
      },
    },
  },
});
